import React, { useState, useEffect, useMemo } from 'react';
import styles from './TenantsTable.module.css'; // 원하는 스타일 적용
import dayjs from 'dayjs';
import { InnocodeButton, InnocodeDatatable } from '@intsoft/innocode-core';

export const ADMINROLE = {
  SYS_ADMIN: 'SYS_ADMIN',
  ADMIN_USER: 'ADMIN_USER'
}

const TenantsTable = ({ datas, onAddUser, detailUser, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow }) => {
  const [searchType, setSearchType] = useState("userId");

  const tenantTypeView = (type) => {
    switch (String(type || '').toLowerCase()) {
      case 'owner':
        return '소유주 (owner)';
      case 'manager':
        return '관리자 (manager)';
      default:
        return '일반유저 (user)';
    }
  };

  const dateView = (dateView) => { 
    const date = new Date(dateView);
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  const handleStatusChange = (e) => {
    setSearchType(e.target.value);
  };

  // 행 클릭 핸들러
  const handleRowClick = (row) => {
    const tenantUserId = row.currentUserPermission?.tenantUserId;

    detailUser(row.tenantId, tenantUserId, row.currentUserPermission?.tenantType);
  };

  // 컬럼 정의
  const columns = useMemo(() => {
    const baseColumns = [
      {
        id: 'tenantName',
        header: '테넌트 명',
        accessorKey: 'tenantName',
        enableSorting: true,
        cell: ({ row }) => <span>{row.tenantName}</span>,
      },
      {
        id: 'permission',
        header: '권한',
        accessorKey: 'currentUserPermission.tenantType',
        enableSorting: true,
        cell: ({ row }) => <span>{tenantTypeView(row.currentUserPermission?.tenantType)}</span>,
      },
    ];

    // 모바일이 아닐 때만 등록일 컬럼 추가
    if (!isMobileWindow) {
      baseColumns.push({
        id: 'createdDate',
        header: '등록일',
        accessorKey: 'createdDate',
        enableSorting: true,
        cell: ({ row }) => <span>{dateView(row.createdDateView)}</span>,
      });
    }

    return baseColumns;
  }, [isMobileWindow]);

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
        <div className={styles.actionBar}>
          {/* <select name={"status"}
            className={styles.rightCont__cont__select} value={searchType}
            style={{ appearance: "auto", padding: '10px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
            onChange={handleStatusChange}>
            <option value={"userId"} defaultValue={true}>아이디</option>
            <option value={"groupId"}>그룹명</option>
          </select>
          <input
            className={styles.rightCont__cont__search}
            type="text"
            placeholder="아이디, 사용자 검색"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              padding: '10px 20px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
          <button
            onClick={() => onSearch(searchType, searchValue)}
            className={styles.addBtn}
          >
            검  색
          </button> */}
        </div>
          <>
            {/* 오른쪽: 버튼 묶음 */}
            <div className={styles.actionBar}>
                <InnocodeButton
                designType="primary"
                theme="line"
                size="md"
                onClick={onAddUser}
                // className={styles.addBtn}
                >등록</InnocodeButton> 
            </div>
          </>
      </div>
      
      <InnocodeDatatable
        className={styles.dataTable}
        data={datas}
        columns={columns}
        enableTableHeader={true}
        enableSorting={true}
        enableCheckbox={false}
        enablePagination={true}
        manualPagination={true}
        pageSize={listSize}
        totalCount={totalCount}
        currentPage={pageNumber}
        onPageChange={(newPage) => {
          if (newPage > pageNumber) {
            onNextPage();
          } else {
            onPrevPage();
          }
        }}
        onRowClick={handleRowClick}
        emptyMessage="테넌트가 없습니다."
        rowClassName={styles.tableRow}
      />
    </div>
  );
};

export default TenantsTable;
